// components/ConnectionStatus.jsx
import React, { useState, useEffect } from 'react';
import './ConnectionStatus.css';

function ConnectionStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [serverError, setServerError] = useState(null);
    const [networkError, setNetworkError] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Слушаем изменения статуса интернета
        const handleOnline = () => {
          
            setIsOnline(true);
            setNetworkError(null);
            setIsVisible(false); 
               
        };
        
        const handleOffline = () => {
             
            setIsOnline(false);
            setNetworkError('Нет подключения к интернету');
            setIsVisible(true);
            
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Слушаем ошибки от api
        const handleNetworkError = (event) => {
            setNetworkError('Ошибка соединения с сервером');
            setIsVisible(true);
            // Через 5 секунд скрываем, если интернет появился
            setTimeout(() => {
                if (navigator.onLine) {
                    setIsVisible(false);
                    setNetworkError(null);
                }
            }, 5000);
        };

        const handleServerError = (event) => {
            setServerError('Сервер временно недоступен. Попробуйте позже.');
            setIsVisible(true);
        };

        window.addEventListener('networkError', handleNetworkError);
        window.addEventListener('serverError', handleServerError);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('networkError', handleNetworkError);
            window.removeEventListener('serverError', handleServerError);
        };
    }, []);

    if (!isVisible && isOnline && !serverError) return null;

    return (
        <div className={`connection-status ${isOnline ? 'server-error' : 'offline'}`}>
            <div className="connection-status-content">
                <div className="connection-status-icon">
                    {isOnline ? '🔌' : '📡'}
                </div>
                <div className="connection-status-message">
                    {!isOnline && 'Нет подключения...'}
                    {isOnline && networkError && networkError}
                    {isOnline && serverError && serverError}
                </div>
                <div className="connection-status-spinner">
                    <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
}

export default ConnectionStatus;